import React from 'react';

import {Link} from 'react-router-dom'
import {locale} from '../locale/AppLocale'
import MainMenu from '../Components/MainMenu';
import LoginPopup from '../Components/LoginPopup';
import {ToastContainer} from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import '@szhsin/react-menu/dist/index.css';
import '@szhsin/react-menu/dist/transitions/slide.css';
import 'react-tooltip/dist/react-tooltip.css'
import * as authActions from "../actions/authActions";
import {connect} from "react-redux";
import Logo from '../assets/images/logo-white.svg';

class LayoutComponent extends React.Component {

    render() {
        return (
            <div>
                <LoginPopup/>
                <ToastContainer />
                <header className="header">
                    <Link to={this.props.logoUrl} className="header--logo">
                        <img
                            src={Logo}
                            width={60}
                            alt=""/>
                    </Link>
                    <MainMenu {...this.props}/>
                </header>
                <div className="clearfix"></div>
                <div className="">
                    <div className="main-content">
                        {this.props.children}
                    </div>
                </div>
                <div className="clearfix"></div>
                <footer className="footer">
                    <div className="container">
                        {locale.get('copyrights')}
                    </div>
                </footer>
            </div>
        )
    }
}



const mapStateToProps = (state, ownProps) => {
    return {
        auth: state.auth,
    }
};


// Maps actions to props
const mapDispatchToProps = (dispatch) => ({

});
export default connect(mapStateToProps, mapDispatchToProps)(LayoutComponent);

